import DashboardChartLawsuitCountTypeFilter from "./DashboardChartLawsuitCountTypeFilter";

export default DashboardChartLawsuitCountTypeFilter;
